"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteDoctorSubstituteContractApiResponseSchema = void 0;
const zod_1 = require("zod");
exports.deleteDoctorSubstituteContractApiResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
});
